/*#__PURE__*/ export default JSON.parse('{"key":"search","type":"root","items":[{"key":"searchPagePath","def":"search","type":"string"}]}');